export default class ProjectTag {
  id;
  name;
  constructor(data) {
    this.id = data.id;
    this.name = data.title;
  }
}
